import type { ChatId } from '../../shared/chats';
import type { T } from '../i18n/translate';

/** "Kórspjall", "Tenór 1", … */
export function chatName(id: ChatId, t: T): string {
  return id === 'choir' ? t('chat.name.choir') : t(`section.${id}`);
}
